import React, { useEffect, useState } from 'react';
import DocumentLink from '../../components/documents/DocumentLink';
import PageTab from '../../components/dashboard/PageTab';
import PageTabTitle from '../../components/dashboard/PageTabTitle';
import PageTabBody from '../../components/dashboard/PageTabBody';

const RevisionDocuments = () => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    try {
      const context = require.context('/public/meetingsDocuments/revisions', false, /\.pdf$/);
      const docs = context.keys();

      setDocuments(docs);
    } catch (error) {
      console.error("Directory '/public/meetingsDocuments/revisions' does not exist.");
    }
  }, []);

  return (
    <PageTab>
      <PageTabTitle>Revizijos aktai</PageTabTitle>
      <PageTabBody>
        {documents.map((filename, index) => (
          <DocumentLink key={index} directory={'/meetingsDocuments/revisions'} filename={filename} />
        ))}
      </PageTabBody>
    </PageTab>
  );
};

export default RevisionDocuments;
